// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1OYUC","content":"styles_content__26aN_","selectAll":"styles_selectAll__5TQHc"};